var utils = require('../../utils')

export default {
  name: 'phrase-list',
  data: function () {
    return {
      wordPhrase: '',
      phraseTypeId: '',
      isShowNewPhrase: false,
      newPhraseType: '',
      newPhrase: '',
      currentEditKey: '',
      utils: utils,
      searchCallbackFlag: false,
      sortKey: '',
      sortStateOrder: '',
      sortState: {
        'm_phrase.phrase_type_id': {'state':false, 'order': false},
        'phrase':                  {'state':false, 'order': false},
        'using_count':             {'state':true , 'order': false} // desc
      },
      sortStateInit: {}
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロールイベント削除
    next()
  },
  created: function () {
    // システム管理者 または 薬剤師
    this.$store.dispatch('USER_ADMIN_PHARMACIST')

    var ssPhraseTypeID = window.sessionStorage.getItem('pl-phraseTypeId')
    var ssWordPhrase = window.sessionStorage.getItem('pl-wordPhrase')
    var ssSortKey = window.sessionStorage.getItem('pl-sortKey')
    var ssSortStateOrder = window.sessionStorage.getItem('pl-sortStateOrder')
    if (!!ssPhraseTypeID) {
      this.phraseTypeId = ssPhraseTypeID
    }
    if (!!ssWordPhrase) {
      this.wordPhrase = ssWordPhrase
    }
    if (!!ssSortKey) {
      var key = ssSortKey
      this.sortKey = key
      if (ssSortStateOrder != null) {
        if (ssSortStateOrder === "true") {
          this.sortStateOrder = true
        } else {
          this.sortStateOrder = false
        }
      } else {
        this.sortStateOrder = !this.sortState[key].order
      }
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = this.sortStateOrder
    }

    // ソート初期化用保存
    for (var k in this.sortState) {
      this.sortStateInit[k] = {}
      this.sortStateInit[k].state = this.sortState[k].state
      this.sortStateInit[k].order = this.sortState[k].order
    }

    this.serchPhraseType()
    this.search(false)

    // 最下部スクロールイベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  computed: {
    phrases() {
      return this.$store.getters.uncategorizedPhrases
    },
    phraseTypes() {
      return this.$store.getters.phraseTypes
    },
    nextPage() {
      return this.$store.getters.phrasesNextPage
    },
    loading() {
      return this.$store.getters.apiLoading
    },
    /** システム管理者 または 薬剤師確認 */
    isAdminOrPharmacist() {
      return this.$store.getters.userAdminOrPharmacist
    },
    totalCount() {
      return this.$store.getters.phrasesTotalCount
    },
    currentPage() {
      return this.$store.getters.phrasesCurrentPage
    },
    /** 通知 */
    notify() {
      return this.$store.getters.phrasesNotify
    }
  },
  methods: {
    /** 検索 */
    search: function (readMore) {
      var url = '/phrases'
      var clear = true
      var loadparams = 'true'

      if (readMore === 'sort') {
        // ソート読み込み
        clear       = false
        loadparams  = 'block'
      } else if (readMore) {
        url = this.nextPage
        clear = false
        loadparams = 'block'
      } else {
        this.searchCallbackFlag = false
      }
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }

      var data = {
        'phrase':           this.wordPhrase,
        'phrase_type_id':   this.phraseTypeId,
        'mode':             'phrase_search',
        'order':            this.orderByString(),
      }
      if (readMore === 'sort') {
        // ソート、再読込 現在のページを指定
        data['current_page'] = this.currentPage
      } else {
        data['current_page'] = null
      }

      if (!!this.phraseTypeId) {
        window.sessionStorage.setItem('pl-phraseTypeId', this.phraseTypeId)
      } else {
        window.sessionStorage.removeItem('pl-phraseTypeId')
      }
      if (!!this.wordPhrase) {
        window.sessionStorage.setItem('pl-wordPhrase', this.wordPhrase)
      } else {
        window.sessionStorage.removeItem('pl-wordPhrase')
      }
      if (!!this.sortKey) {
        window.sessionStorage.setItem("pl-sortKey", this.sortKey)
      } else {
        window.sessionStorage.removeItem("pl-sortKey")
      }
      if (this.sortStateOrder !== "") {
        window.sessionStorage.setItem("pl-sortStateOrder", this.sortStateOrder)
      } else {
        window.sessionStorage.removeItem("pl-sortStateOrder")
      }
      this.$store.dispatch('PHRASE_SEARCH', { url: url, clear: clear, data: data, loadparams: loadparams, callback: callback})
    },
    /** カテゴリ一覧の取得 */
    serchPhraseType: function () {
      var url = '/phrases'
      this.$store.dispatch('PHRASE_TYPE_SEARCH', { url: url })
    },
    /** 編集ボタン */
    editPhrase: function (key) {
      // 新規登録モードを終了する
      this.isShowNewPhrase = false

      // 現在編集中のリストを元の状態に戻す
      this.finishEditMode()

      // 対象のレコードを編集状態にする
      this.changeEditMode(this.phrases[key], true)

      // 編集モードキーを更新
      this.currentEditKey = key
    },
    /** 削除処理 */
    deletePhrase: function (key) {
      var phraseId = this.phrases[key].attributes['phrase-id']
      var self = this
      var callback = function () {
        // 再検索
        self.search('sort')
      }
      this.$store.dispatch('PHRASE_DELETE', { phraseId: phraseId, callback: callback })

    },
    /** キャンセルボタン(明細行） */
    editCancel: function (key) {
      this.changeEditMode(this.phrases[key], false)
    },
    /** 保存ボタン(明細行) */
    editSave: function (key) {
      var attrs = this.phrases[key].attributes

      var data = {
        'phrase_id': attrs['phrase-id'],
        'phrase': attrs['phrase']
      }
      this.$store.dispatch('PHRASE_SAVE', { data: data })

      // 表示中の内容を隠し領域にコピー
      attrs['hide-phrase'] = attrs['phrase']

      // 編集モードの終了
      this.finishEditMode()
    },
    /** 新規登録ボタン */
    showNewPhrase: function () {
      // 現在編集中のリストを元の状態に戻す
      this.finishEditMode()
      this.isShowNewPhrase = true
    },
    /** 保存ボタン(新規登録) */
    newPhraseSave: function () {

      // 入力チェック
      if (utils.isBlank(this.newPhrase, true)) {
        return
      }
      var data = {
        'phrase': this.newPhrase,
        'phrase_type_id': this.newPhraseType || '1'
      }
      var self = this
      var callback = function () {
        // 新規登録終了
        self.newPhraseCancel()
        // 再検索
        self.search('sort')
      }
      this.$store.dispatch('PHRASE_SAVE', { data: data, callback: callback })
    },
    /** キャンセルボタン(新規登録) */
    newPhraseCancel: function () {
      this.isShowNewPhrase = false
      this.newPhrase = ''
      this.newPhraseType = ''
    },
    /** 削除確認前処理 */
    preDeleteConfirm: function (key) {
      // 編集モードキーを更新
      this.currentEditKey = key
    },
    /** 編集行切り替え */
    changeEditMode: function (obj, editMode) {
      if (obj) {
        obj['editMode'] = editMode
        if (!editMode) {
          // 編集内容を破棄し、元の状態に戻す
          obj.attributes['phrase'] = obj.attributes['hide-phrase']
        }
        this.notifyArrayChanged(this.findPhraseListKey(obj))
      }
    },
    /** 未入力時に必須スタイルを返却 */
    getRequiredClass: function (text) {
      return utils.isBlank(text) ? 'required' : ''
    },
    /** 未入力時に非活性スタイルを返却 */
    getDisabledClass: function (text) {
      return utils.isBlank(text) ? 'disabled' : ''
    },
    finishEditMode: function () {
      this.newPhraseCancel()
      for (var key in this.phrases) {
        if (this.phrases[key]['editMode']) {
          this.changeEditMode(this.phrases[key], false)
        }
      }
    },
    notifyArrayChanged: function (key) {
      this.phrases.splice(key, 1, this.phrases[key])
    },
    findPhraseListKey: function (obj) {
      for (var key in this.phrases) {
        if (obj == this.phrases[key]){
          return key
        }
      }
    },
    sortBy: function(key) {
      // 現在編集中のリストを元の状態に戻す
      this.finishEditMode()
      this.sortKey = key
      this.sortStateOrder = !this.sortState[key].order
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = !this.sortState[key].order

      // 検索
      this.search('sort')
    },
    getArrow: function(key) {
      var state = this.sortState[key].state ? ' color-light-blue' : ''
      var arrow = this.sortState[key].order ? 'fa-arrow-up' : 'fa-arrow-down'
      return arrow + state
    },
    /** ソート文字列取得 */
    orderByString: function() {
      var result = []
      for (var key in this.sortState) {
        if (this.sortState[key].state) {
          var asc_desc = 'asc'
          if (!this.sortState[key].order) {
            asc_desc = 'desc'
          }
          if (key !== 'm_phrase.phrase_type_id') {
            result.push('m_phrase.phrase_type_id asc')
          }
          result.push(key + ' ' + asc_desc)
        }
      }
      if (result.length <= 0) {
        // 存在しない場合
        result.push('m_phrase.phrase_type_id asc, using_count desc')
      }
      return result.join(' , ')
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/phrase-list.js